module.exports = __webpack_public_path__ + "static/red-cross-2615bdc9a8eaeab80d8bdec29f56bfa5.png";